export function createAsyncCases(builder, asyncThunk, onSuccess, onError) {
    var handleSuccess = function (state, action) {
        state.fetch_data = action.payload.fetch_data;
        state.status = action.payload.status;
        if (action.payload.status === 200) {
            state.error = null;
            state.data = typeof action.payload.data === 'string' ? {} : action.payload.data;
        }
        else {
            state.data = null;
            state.error = action.payload.data;
        }
        if (onSuccess) {
            onSuccess(state, action);
        }
    };
    var handleError = function (state, action) {
        state.fetch_data = null;
        state.error = 'Unknown error';
        if ('error' in action.payload) {
            state.error = action.payload.error;
        }
        else if ('message' in action.payload) {
            state.error = action.payload.message;
        }
        else if (typeof action.payload === 'string') {
            state.error = action.payload;
        }
        if (onError) {
            onError(state, action);
        }
    };
    builder
        .addCase(asyncThunk.pending, function (state) {
        state.loading = true;
    })
        .addCase(asyncThunk.fulfilled, function (state, action) {
        handleSuccess(state, action);
    })
        .addCase(asyncThunk.rejected, function (state, action) { return handleError(state, action); });
}
